import { combineReducers } from 'redux';
import authentication from '../store/reducers/login';
import dashboardReducer from '../store/reducers/dashboardReducer';
import downloads from "../store/reducers/downloads"
import loader from "../store/reducers/loader"
import proposalReducer from '../store/reducers/proposalReducer'
// import HierarchyReducer from '../reducers/HierarchyReducer'
import createapp from "../store/reducers/createApp"
import logs from '../store/reducers/logs';
import switchApiReducer from '../store/reducers/switchApiReducer';
import paymentPatchingReducer from '../store/reducers/paymentPatchingReducer';
import smsEmailReducer from "../store/reducers/smsEmailReducer";
import productConfigReducer from "../store/reducers/productConfigReducer";
import paymentReducer from '../store/reducers/paymentReducer';
const rootReducer = combineReducers({
  authentication: authentication,
  dashboardData: dashboardReducer,
  downloads: downloads,
  loader: loader,
  createapp: createapp,
  proposal: proposalReducer,
  logs: logs,
  switchApiReducer,
  paymentPatchingReducer,
  smsEmailData: smsEmailReducer,
  productTypeData: productConfigReducer,
  paymentReducer:paymentReducer
  // TrackerData: TrackerReducer,
  // HierarchyData: HierarchyReducer
});

export default (state, action) =>
  rootReducer(action.type === 'USER_LOGOUT' ? undefined : state, action);
